const renewalTerm = `
    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>TERMO ADITIVO CONTRATUAL – “AC”</strong></p>
            </td>
        </tr>
        <tr>
            <td>
            <div class="main">

                <p>
                    O presente instrumento particular complementa e detalha o Contrato de Prestação de Serviços em Informática realizado em {{contractstart}}, firmado entre as partes a seguir qualificadas
                </p>

                <p>
                    De um lado, <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA.</strong>, regularmente inscrita no CNPJ/MF sob o nº 03.775.758/0001-90, com sede na Rua Bela Cintra, 986, 2º andar, CEP 01415-906, Consolação - São Paulo/SP, designada <strong>“CONTRATANTE”</strong>. E, de outro lado, <strong>{{companyname}}</strong>, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº {{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, neste ato representada por {{consultantname}}, brasileiro(a), {{consultantcivilstatus}}, possuidor do RG nº {{consultantrg}}, inscrito no CPF/MF sob o nº {{consultantcpf}}, residente e domiciliado {{consultantaddress}}, nº {{consultantnumber}}, CEP.{{consultantcep}}, {{consultantcity}}/{{consultantstate}}, doravante designada <strong>“CONTRATADA”</strong>.
                </p>

                <p style="border: solid 1px #000;">
                    <strong>1. VIGÊNCIA </strong><br>
                    <strong>1.1. Renova-se a vigência do presente contrato que vigorará por prazo indeterminado, tendo-se como início a data de assinatura deste instrumento.</strong>
                </p>

                <p>
                    E por estarem assim justas e contratadas, assinam as partes o presente instrumento, em duas vias de igual teor e forma, perante a presença de seus representantes legais e duas testemunhas presenciais.
                </p>

                <br>
                </td>
                </tr>
                <tr>
                <td align="center" height='60px'>

                <p style="text-align: center; margin-top: 50px;">
                    <strong>São Paulo</strong>, {{datecontract}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA
                        CONTRATANTE</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{companyname}}<br>
                        <br><strong>CONTRATADA</strong>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
        </tr>
    </table>
`;

export default renewalTerm;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/renewalTerm.ts